import { withProjectPrefix } from '@/modules/project/route-util';

type RouteContext = {
  projectId: string;
  hasProjectUrl: boolean;
};

export const buildDocumentsRootPath = ({ projectId, hasProjectUrl }: RouteContext): string =>
  withProjectPrefix('/documents', hasProjectUrl ? projectId : undefined);

export const buildDocumentFolderPath = ({
  folderId,
  projectId,
  hasProjectUrl,
}: RouteContext & {
  folderId: string;
}): string => `${buildDocumentsRootPath({ projectId, hasProjectUrl })}/folder/${folderId}`;

export const buildDocumentDetailPath = ({
  documentId,
  projectId,
  hasProjectUrl,
}: RouteContext & {
  documentId: string;
}): string => `${buildDocumentsRootPath({ projectId, hasProjectUrl })}/${documentId}`;
